import { render, staticRenderFns } from "./niveles.vue?vue&type=template&id=34862fe9&"
import script from "./niveles.vue?vue&type=script&lang=js&"
export * from "./niveles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports